import { Box, List, ListItemText, useTheme } from "@mui/material";
import React, { memo, useMemo } from "react";
import {
  KeyboardArrowDownRounded as KeyboardArrowDownRoundedIcon,
  CheckRounded as CheckRoundedIcon,
} from "components/icon/mui_icon";
import usePopper from "hooks/usePopper";
import StyledListItemButton from "components/layout/sidebar/UI/StyledListItemButton.style";
import StyledButton from "customStyled/StyledButton";

const StatusDropdownUI = ({
  value,
  colorValue,
  statusValue,
  rowCellClick,
  data,
  dropdownOptions = [],
  isDisabled = false,
}) => {

  const obj = useMemo(
    () => ({
      closeOnChange: true,
      id: "status-dropdown",
      onChange: (newValue) => {
        if (!!rowCellClick && value !== newValue) {
          rowCellClick("statusUpdate", { ...data, newValue });
        }
      },
      sx: {
        ".MuiPaper-root": {
          minWidth: 160,
        },
      },
    }),
    [data, rowCellClick, value],
  );
  const { openPopper, PopperWrapper, handleChange, id } = usePopper(obj);

  const option = useMemo(() => {
    let temp = null;
    if (dropdownOptions.length) {
      temp = dropdownOptions.find((el) => el.value === value);
    }
    return !!temp ? temp : { label: value, value };
  }, [dropdownOptions, value]);

  return (
    <React.Fragment>
      <Box sx={{ position: "relative" }} aria-describedby={id}>
        <ChipUI
          {...option}
          colorValue={colorValue}
          statusValue={statusValue}
          isDisabled={isDisabled}
          onClick={openPopper}
        />
        <PopperWrapper>
          <List sx={{ p: 0.5 }}>
            {dropdownOptions.map((option, index) => (
              <StyledListItemButton
                key={option.value || index}
                onClick={() => handleChange(option.value)}
                sx={{ padding: 0.5 }}
              >
                <ListItemText sx={{ margin: 0 }}>
                  <ChipUI
                    {...option}
                    statusValue={statusValue}
                    sx={{ height: 24 }}
                    isDisabled={true}
                  />
                </ListItemText>
                {value === option.value ? (
                  <CheckRoundedIcon sx={{ fill: "#51555C" }} />
                ) : null}
              </StyledListItemButton>
            ))}
          </List>
        </PopperWrapper>
      </Box>
    </React.Fragment>
  );
};

export default memo(StatusDropdownUI);

const ChipUI = ({
  value,
  isDisabled = false,
  label = null,
  statusValue,
  colorValue,
  onClick,
  sx = {},
}) => {
  const theme = useTheme();
  const { color, background, icon } = theme.palette.status[
    colorValue ?? value
  ] ?? {
    color: null,
    background: null,
    icon: null,
  };
  return (
    <StyledButton
      size="small"
      sx={{
        color,
        background,
        ...sx,
        borderRadius: 5,
        height: 24,
        padding: "2px 10px",
        textTransform: 'inherit',
        ...(isDisabled
          ? {
              pointerEvents: "none",
            }
          : {}),
        ...(isDisabled
          ? {}
          : {
              "&:hover": {
                background,
                color,
              },
            }),
      }}
      // component="chip"
      endIcon={
        isDisabled ? null : <KeyboardArrowDownRoundedIcon sx={{ fill: icon }} />
      }
      // onDelete={() => null}
      onClick={isDisabled ? null : onClick}
    >
      {!!label
        ? label
        : typeof statusValue === "function"
          ? statusValue(value)
          : value}
    </StyledButton>
  );
};
